import './vendor/swiper';
import './vendor/select';
import './vendor/init-form-validate';
import './vendor/move-to';
import {initAutoresizeTextarea} from './vendor/autoresize-textarea';
import {initAccordion} from './vendor/accordion';

initAccordion();
initAutoresizeTextarea();
